import * as actionType from '../actionTypes';

const initialState = {
    paymentData: [],
    paymentMsg: ""
}

const paymentPatchingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.PAYMENT_PAYLOAD:
            return {
                ...state,
                paymentData: action.payload
            }
        case actionType.PAYMENT_MSG:
            return {
                ...state,
                paymentMsg: action.payload
            }
        default : return state
    }
}

export default paymentPatchingReducer